import { httpClient } from './httpClient';

export const createCheckoutSession = async (companyId, priceId, mode, trial_days = null, campaignCode = null, userId = null) => {
  const response = await httpClient.post(`/create-checkout-session`, { company_id: companyId, price_id: priceId, mode, trial_days, campaign_code: campaignCode, user_id: userId })
  return response.data
}